import { render } from "./sti-detail.vue?vue&type=template&id=0dd4fc6e&ts=true"
import script from "./sti-detail.vue?vue&type=script&lang=ts"
export * from "./sti-detail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__